import useEvent from '@lyearn/core/hooks/useEvent';
import { useTranslation } from '@lyearn/i18n';
import { AlertDialog, DialogEntity } from '@lyearn/molecules';
import useExportJobMutation from '@/modules/corporate/components/BulkExport/hooks/useExportJobMutation';
import { JobPurposeEnum, QuizQuestionExportFieldEnum } from '@/types/schema';

import { QuizExportDialogProps } from './types';

const purpose = JobPurposeEnum.QuizQuestionExport;
const fields = [
  QuizQuestionExportFieldEnum.Question,
  QuizQuestionExportFieldEnum.QuestionType,
  QuizQuestionExportFieldEnum.CorrectOption,
  QuizQuestionExportFieldEnum.Shuffle,
  QuizQuestionExportFieldEnum.Difficulty,
  QuizQuestionExportFieldEnum.SkillId,
  QuizQuestionExportFieldEnum.SkillName,
  QuizQuestionExportFieldEnum.CorrectAnswerExplanation,
  QuizQuestionExportFieldEnum.IncorrectAnswerExplanation,
  QuizQuestionExportFieldEnum.Options,
];

const QuizExportDialog = (props: QuizExportDialogProps) => {
  const { t } = useTranslation();
  const { image, quiz, onClose } = props;
  const { fetching, onExport } = useExportJobMutation({ purpose });

  const onSubmit = useEvent(() => {
    onExport({
      quizQuestionExportInput: {
        filters: { quizId: quiz.id },
        requiredFields: { fields },
      },
    }).then((response) => {
      if (response.data?.createImportJob?.id) {
        onClose();
      }
    });
  });

  return (
    <AlertDialog
      header={{
        title: t('Admin:ExportQuiz.ExportQuiz'),
        description: t('Admin:ExportQuiz.ExportQuizDescription'),
      }}
      primaryAction={{
        loading: fetching,
        label: t('Admin:ExportQuiz.ExportQuiz'),
        onClick: onSubmit,
      }}
      onClose={onClose}>
      <DialogEntity description={t('Common:ResourceType.Quiz')} image={image} title={quiz.name} />
    </AlertDialog>
  );
};

export default QuizExportDialog;
